export enum StripeType {
  SET_PRICE_ID = 'StripeType/SET_PRICE_ID',
  SET_PRICE = 'StripeType/SET_PRICE'
}

export type AddEmployeeUserItem = {
  mail: string
  uuid?: string
  firstname?: string
  lastname?: string
  company?: string
  status: 0 | 1 | 2 | 99 | -1 // -1: unknonw,  0 = already payed by you, 1 not payed by you, 2: user does not existn 99 eroor
}
